import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../assets/images/emptysaved.png';

function TemplateMessageEmpty({ title, subtitle }) {
  return (
    <div className="template-main-container">
      <div className="sub-container">
        <div className="no-time-plan-data">
          <img
            alt="Empty state"
            src={Image}
            loading="lazy"
            role="presentation"
          />
        </div>
        <div className="no-data-message">
          <div className="message-title">
            <span className="message-header">{title}</span>
            <span className="message-line">
              {subtitle}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
TemplateMessageEmpty.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default TemplateMessageEmpty;
